/*
 * Forge Maestro
 * (c) Honeywell
 */

const isNil = (value) => value === null || value === undefined;
const isNotNil = (value) => !isNil(value);

export { isNil, isNotNil };
//# sourceMappingURL=is-nil.js.map
